import React from "react";
import styles from "./ServiceGridSection.module.css";
import ServiceCard from "../../../components/ServiceCard/ServiceCard";

interface ServiceData {
    id?: number;
    image: string;
    agentAvatar: string;
    agentName: string;
    title: string;
    rating: number;
    reviewCount: number;
    location: string;
    price: number;
    status?: "Available" | "Busy";
}

interface ServiceGridSectionProps {
    title: string;
    subtitle?: string;
    services: ServiceData[];
}

function ServiceGridSection({ title, subtitle, services }: ServiceGridSectionProps) {
    return (
        <section className={styles.sectionContainer}>
            <div className={styles.header}>
                <h2>{title}</h2>
                {subtitle && <p>{subtitle}</p>} 
            </div>

            <div className={styles.grid}>
                {services.map((service, index) => (
                    <ServiceCard
                        key={service.id || index}
                        image={service.image}
                        agentAvatar={service.agentAvatar}
                        agentName={service.agentName}
                        title={service.title}
                        rating={service.rating}
                        reviewCount={service.reviewCount}
                        location={service.location}
                        price={service.price}
                        status={service.status}
                        showBookmark={true} 
                    />
                ))}
            </div>
        </section>
    );
}

export default ServiceGridSection;